<i18n>
{
  "de": {
    "pollMaxAnswers": "Max. {maxAnswers} Antworten möglich",
    "please": "Bitte",
    "doLogin": "einloggen",
    "toVote": "um abzustimmen",
    "sendVote": "Abstimmen"
  },
  "en": {
    "pollMaxAnswers": "choose up to {maxAnswers} answers",
    "please": "Please",
    "doLogin": "login",
    "toVote": "to vote",
    "sendVote": "Vote"
  }
}
</i18n>

<template lang="html">
  <section v-if="pollData && pollData.active">
    <transition
      name="poll"
      mode="out-in"
    >
      <div
        v-if="!pollData.hasVoted"
        key="options"
        class="panel"
      >
        <div class="panel-heading is-primary">
          <span>{{ pollData.question }}</span>
          <div
            v-if="available && pollData.multiple"
            class="is-size-6"
          >
            ({{ $t('pollMaxAnswers', { maxAnswers: Math.min(pollData.options.length, pollData.maxAnswers || 1) }) }})
          </div>
        </div>
        <div
          v-if="available"
          class="options"
        >
          <div
            v-for="option in filteredOptions"
            :key="option._id"
            class="panel-block"
          >
            <input
              :id="option._id"
              v-model="voted"
              class="is-checkradio is-circle is-block is-danger"
              :type="pollData.multiple ? 'checkbox' : 'radio'"
              :value="option._id"
              :disabled="pollData.multiple && !hasVotesRemaining && !isSelected(option._id)"
            >
            <label
              :for="option._id"
              class="poll-label"
            >
              {{ option.title }}
            </label>
          </div>
        </div>
        <article
          v-else
          class="placeholder"
        >
          <div class="placeholder-content-wrapper">
            <div class="placeholder-text">
              <p class="placeholder-vote">
                {{ $t('please') }} <nuxt-link
                  v-if="!isAuthenticated"
                  :to="localePath({ name: 'portal-login' })"
                >
                  {{ $t('doLogin') }}
                </nuxt-link> {{ $t('toVote') }}
              </p>
            </div>
          </div>
        </article>
        <div
          v-if="isAuthenticated"
          class="panel-block"
        >
          <button
            :disabled="!voted.length"
            class="button is-primary is-fullwidth"
            @click="sendPollVote"
          >
            {{ $t('sendVote') }}
          </button>
        </div>
      </div>
      <div
        v-else
        key="result"
        class="panel"
      >
        <div class="panel-heading is-primary">
          {{ pollData.question }}
        </div>
        <div
          v-for="option in filteredOptions"
          :key="option._id"
          class="panel-block"
        >
          <div class="column is-half">
            <label class="is">{{ option.title }}</label>
          </div>
          <div class="column is-one-third">
            <div
              class="bar"
              :style="{ width: getRelativePercentage(pollData.options, option) + '%' }"
            />
          </div>
          <div class="column has-text-right">
            {{ getRelativePercentage(pollData.options, option) }}%
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['poll'],
  data: () => ({
    voted: [],
    pollData: {}
  }),
  computed: {
    available() {
      return !this.poll.notAvailable
    },

    filteredOptions() {
      return this.pollData.options ? this.pollData.options.filter(option => option.title) : []
    },

    hasVotesRemaining() {
      return ((this.pollData.maxAnswers || 1) - this.voted.length) > 0
    },
    ...mapState(['isAuthenticated'])
  },
  methods: {
    isSelected(id) {
      return this.voted.includes(id)
    },
    async sendPollVote() {
      const pollVoted = await this.apiPost(`/api/private/polls/${this.pollData._id}/vote`, {
        optionIds: typeof this.voted === 'string' ? [this.voted] : this.voted
      })
      if (pollVoted) {
        this.pollData = pollVoted.poll
        this.$store.dispatch('refreshPollData', this.pollData)
      }
    }
  },
  created() {
    this.pollData = this.poll
  }
}
</script>

<style lang="scss">
.poll-enter-active,
.poll-leave-active,
.result-enter-active,
.result-leave-active {
  transition: opacity .5s;
}

.poll-enter,
.poll-leave-to,
.result-enter,
.result-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.bar {
  height: 1rem;
  background-color: grey;
}

article.placeholder {
  border-top: none;
  margin-top: 10px;
}

.panel-block {
  align-items: center;
  color: #121212;
  display: flex;
  justify-content: flex-start;
  padding: 0.5em 0.75em;

  label {

    &::before,
    &:after {
      margin-top: 3px;
    }
  }
}
</style>
